import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// const [data, setData] = useState('')
const initialState = {
    isLogin: false,
    spIssue: {},
    toastData: {},
};

const homeSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setSpIssueById(state, action) {
            state.spIssue = action.payload;
        },
        settoastData(state, action) {
            state.toastData = action.payload;
        },
    },
});

export const { settoastData, setSpIssueById } = homeSlice.actions;

export const SpissuesgetById = (id) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_URL}/journal/specialissues/${id}`).then((res) => {
        // dispatch(settoastData({ status: true, message: "You are Loged in !" }));
        dispatch(setSpIssueById(res?.data));
        // localStorage.setItem("user", JSON.stringify(res.data))
    })
        .catch((err) => {
            dispatch(settoastData({ status: false, message: err?.response?.data }));
        })
    return response;
}
const spissuesReducer = homeSlice.reducer;

export default spissuesReducer;
